import { CountUp } from 'countup.js'

export default class DatesCount
{
  constructor(view)
  {
    this.view = view
    this.$dates = this.view.querySelectorAll('.jsDate')
    this.animate()
  }


  animate()
  {
    for(let $date of this.$dates) {
      const options = {
      startVal: 0,
      separator: '',
      decimal: '',
        duration: 3.5,
      };
      this.animation = new CountUp($date, $date.getAttribute('data-date'), options);
      this.animation.start()
    }
  }
}
